module.exports = __webpack_public_path__ + "img/3-DayCongress.586e8ad5.svg";